var _path, _path2, _rect, _path3, _path4, _rect2, _path5, _path6, _line, _line2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackagePreview2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 91,
    viewBox: "0 0 138 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.668 4.75599C76.668 7.22057 78.6397 9.21198 81.0639 9.21198C83.4881 9.21198 85.4598 7.22057 85.4598 4.75599C85.4598 2.2914 83.4881 0.3 81.0639 0.3C78.6397 0.3 76.668 2.2914 76.668 4.75599Z",
    stroke: "#050C26",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.641 73.8581C110.641 75.5502 111.995 76.9153 113.656 76.9153C115.317 76.9153 116.671 75.5502 116.671 73.8581C116.671 72.1661 115.317 70.801 113.656 70.801C111.995 70.801 110.641 72.1661 110.641 73.8581Z",
    stroke: "#050C26",
    strokeWidth: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.49163,
    height: 4.49163,
    transform: "matrix(-0.702595 0.71159 0.702595 0.71159 4.1543 50.938)",
    fill: "#00629C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137 32.9556V63.616C137 66.8047 133.451 68.7115 130.792 66.9517L123.051 61.8278H66.4186C64.2095 61.8278 62.4186 60.037 62.4186 57.8278V32.9556C62.4186 30.7464 64.2095 28.9556 66.4186 28.9556H133C135.209 28.9556 137 30.7464 137 32.9556Z",
    fill: "#CCD7E3",
    stroke: "#050C26",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0565 59.9526V83.2355C23.0565 86.4726 26.7011 88.369 29.3521 86.5113L34.2995 83.0442H84.5224C86.7315 83.0442 88.5224 81.2533 88.5224 79.0442V59.9526C88.5224 57.7435 86.7315 55.9526 84.5224 55.9526H27.0565C24.8473 55.9526 23.0565 57.7435 23.0565 59.9526Z",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.757,
    y: 62.0339,
    width: 30.4053,
    height: 15.1011,
    rx: 1.7,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 64.874L55.1279 69.7227C55.6587 69.9671 56.2698 69.9671 56.8006 69.7227L67.3329 64.874",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.101 12.1722C103.493 10.8528 101.056 11.8 100.732 13.8708L97.9977 31.3572C97.6762 33.4134 99.6816 35.0375 101.614 34.2861L117.934 27.9414C119.866 27.1901 120.284 24.6241 118.686 23.314L105.101 12.1722Z",
    stroke: "#050C26",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 54.1168,
    y2: -0.3,
    transform: "matrix(-1 0 0 1 126.918 40.2861)",
    stroke: "#050C26",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 31.4661,
    y2: -0.3,
    transform: "matrix(-1 0 0 1 126.918 48.959)",
    stroke: "#050C26",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.89263,
    height: 7.89263,
    transform: "matrix(-0.702595 0.71159 0.702595 0.71159 88.3633 77.4736)",
    fill: "#E86E4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagePreview2);
export default __webpack_public_path__ + "static/media/package-preview-2.25d51efc1cbe487d9fefc4a90c87b042.svg";
export { ForwardRef as ReactComponent };